import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var Rate = function Rate(props) {
  var _getThemeData = getThemeData(props, 'rate'),
    Color = _getThemeData.Color,
    fontSize = _getThemeData.fontSize;
  return css([".c7n-rate.c7n-rate{color:", ";line-height:1;.icon{font-size:", "px;}}.c7n-rate-text.c7n-rate-text{font-size:0.14rem;color:rgba(0,0,0,0.65);line-height:22px;}"], Color, fontSize);
};
export default Rate;